import type { AppRouteRecordRaw } from "../types/types";

import { RouteNames } from "@/app/router/types/names";
import { PermissionGroups, Permissions } from "@/shared/constants";

const adminRoutes: AppRouteRecordRaw[] = [
  {
    path: "/admin",
    name: "admin-parent",
    redirect: "/admin/users",
    meta: {
      menuIcon: "lucide:shield",
      menuTitle: "Admin",
      isMenuParent: true,
      permissions: PermissionGroups.ADMIN,
    },
    children: [
      {
        path: "users",
        name: RouteNames.USERS,
        meta: {
          permissions: [Permissions.ADMIN],
          title: "Users Management",
          menuTitle: "Users",
          menuIcon: "lucide:users",
          filters: {
            show: [],
          },
        },
        component: () => import("@/pages/Admin/UsersList.vue"),
      },
      {
        path: "/communication",
        name: RouteNames.COMMUNICATION,
        meta: {
          permissions: [Permissions.EMAILS],
          menuTitle: "Communication",
          menuIcon: "lucide:mail",
          title: "Mail Communication",
          filters: {
            show: [],
          },
        },
        component: () => import("@/pages/Admin/MailCommunication.vue"),
      },
      {
        path: "users/:userId",
        name: RouteNames.EDIT_USER,
        meta: {
          permissions: [Permissions.ADMIN],
          title: "Edit User",
          showInMenu: false,
          filters: {
            show: [],
          },
        },
        component: () => import("@/pages/Admin/UserInfo.vue"),
      },
    ],
  },

];

export default adminRoutes;
